//  OverviewCard.js
//
//  Updated 2/3.
//
//  Abstract: Overview cards rendered on overview page.
//  TODO: add click links...

//  React
import React, { useState } from 'react';
import clsx from 'clsx';

//  Material-ui components
import { makeStyles, CssBaseline, Card, CardHeader, CardContent, CardActions, Collapse, Avatar, IconButton, Typography, } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';
import DoneIcon from '@material-ui/icons/Done';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import NotesIcon from '@material-ui/icons/Notes';

//  CSS Styles
const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    avatar: {
    },
}));

export default function OverviewCard(props) {

    //  CSS classes
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    //  OverviewCards are rendered based on props provided in component definition in Overview.js component; default props are provided here
    const {
        cardTitle = "Placeholder title",
        cardBody = "Placeholder body",
        cardId = 'Placeholder ID',
        cardSubBody = ''
    } = props

    //  Component rendering
    return (
        <>
            <Card className={clsx(classes.root)} variant="outlined" elevation={0}>
                <CssBaseline />
                <CardHeader
                    avatar={
                        <Avatar aria-label={cardTitle} className={classes.avatar}>
                            {
                                (cardId === 'create' && <CreateIcon />)
                                || (cardId === 'view' && <NotesIcon />)
                                || (cardId === 'review' && <DoneIcon />)
                            }
                        </Avatar>
                    }
                    title={cardTitle}
                />
                <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {cardBody}

                    </Typography>

                    <Typography variant="body2" color="textSecondary" component="p">
                        {cardSubBody}
                    </Typography>

                </CardContent>
                <CardActions disableSpacing>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography paragraph>
                            Method:
                        </Typography>
                    </CardContent>
                </Collapse>
            </Card>
        </>
    );
}